module.exports = flarum.core.compat['components/WelcomeHero'];